import { noop } from '@datadog/browser-core';
import { NodePrivacyLevel } from '../../../constants';
export var DEFAULT_SHADOW_ROOT_CONTROLLER = {
    flush: noop,
    stop: noop,
    addShadowRoot: noop,
    removeShadowRoot: noop,
};
export var DEFAULT_CONFIGURATION = { defaultPrivacyLevel: NodePrivacyLevel.ALLOW };
//# sourceMappingURL=observers.specHelper.js.map